<div *ngIf="show"
     class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 animate-fade-in p-4"
     (click)="close()">
  <div class="relative bg-white rounded-2xl shadow-2xl w-auto max-w-2xl animate-scale-in"
       (click)="$event.stopPropagation()">
    <button
      (click)="close()"
      class="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-all duration-200 hover:scale-110"
      aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    <div class="p-2">
      <img [src]="imageSrc" alt="Información Islas Baleares" class="max-h-[85vh] w-auto rounded-lg">
    </div>
  </div>
</div>
